/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Lock tangent</h4>
<p>Lock or unlock the tangent at either endpoint of an edge.</p>

<p>While in "Tangent" mode, select an edge, clicking closer to the end of interest. Then click this button to lock (or unlock) the tangent of that end.</p>

<!--
<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('703231606')}"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
</div>
-->

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>X:</b> Lock tangent</li>
    <li class='shortcuts__item'><b>Shift-X:</b> Unlock tangent</li>
</ul>`;

export default function FixTangentAtVertexTooltip() {
    return h('div', { innerHTML: body });
}
